<div [ngSwitch]="renderFilter.type" class="h-100">
  <div *ngSwitchCase="'betweenDateTimeRangeFilter'">
    <div ngbDropdown [class]="class" [autoClose]="'outside'" placement="bottom-left" (openChange)="handleDropdownOpen($event)">
      <button class="btn btn-block text-left top-filter-dropdown" ngbDropdownToggle>
        <div class="d-flex align-items-center">
          <span translate>
            {{ renderFilter.displayName || renderFilter.name }}
          </span>
          <i
            class="fa float-right ml-2"
            [ngClass]="{ 'fa-chevron-down': !dropdownIsOpen, 'fa-chevron-up': dropdownIsOpen }"
          ></i>
        </div>
      </button>
      <ul class="top-filter-dropdown-list no-overflow" ngbDropdownMenu>
        <div class="dropdown-date-time-padding" *ngIf="renderFilter.type === 'betweenDateTimeRangeFilter'">
          <lib-filter-between-date-time-range
            [renderFilter]="renderFilter"
            (selectDateTimeRange)="setRangeValues($event)"
          ></lib-filter-between-date-time-range>
        </div>
      </ul>
    </div>
  </div>
  <div *ngSwitchCase="'dateRangeFilter'">
    <div ngbDropdown [class]="class" [autoClose]="'outside'" placement="bottom-left" (openChange)="handleDropdownOpen($event)">
      <button class="btn btn-block text-left top-filter-dropdown" ngbDropdownToggle>
        <div class="d-flex align-items-center">
          <span translate>
            {{ renderFilter.displayName || renderFilter.name }}
          </span>
          <i
            class="fa float-right ml-2"
            [ngClass]="{ 'fa-chevron-down': !dropdownIsOpen, 'fa-chevron-up': dropdownIsOpen }"
          ></i>
        </div>
      </button>
      <ul class="top-filter-dropdown-list no-overflow" ngbDropdownMenu>
        <div class="dropdown-date-padding" *ngIf="renderFilter.type === 'dateRangeFilter'">
          <lib-filter-date-range
            [renderFilter]="renderFilter"
            (selectDateRange)="setRangeValues($event)"
            [changeMax]="renderFilter.maxValue"
            [changeMin]="renderFilter.minValue"
          ></lib-filter-date-range>
        </div>
      </ul>
    </div>
  </div>

    <div *ngSwitchCase="'RangeConfigBaseFilter'">
      <div ngbDropdown [class]="class" [autoClose]="'outside'" placement="bottom-left" (openChange)="handleDropdownOpen($event)">
        <button class="btn btn-block text-left top-filter-dropdown" ngbDropdownToggle>
          <div class="d-flex align-items-center">
            <span translate>
              {{ renderFilter.displayName || renderFilter.name }}
            </span>
            <i
              class="fa float-right ml-2"
              [ngClass]="{ 'fa-chevron-down': !dropdownIsOpen, 'fa-chevron-up': dropdownIsOpen }"
            ></i>
          </div>
        </button>
        <ul class="top-filter-dropdown-list no-overflow" ngbDropdownMenu>
          <div class="dropdown-date-padding">
            <lib-range-slider
              (selectedRangeOutput)="selectedRangeChanged($event)"
              [maxRange]="maxRange"
              [selectedRange]="maxValue && minValue ? { max: maxValue, min: minValue } : undefined"
            ></lib-range-slider>
          </div>
        </ul>
      </div>
    </div>

  <div *ngSwitchCase="'CheckBoxConfigBaseFilter'" class="h-100">
    <div class="form-check form-switch ml-2 h-100 row d-flex align-items-center">
      <input class="form-check-input rounded-pill col-auto" type="checkbox" id="flexSwitchCheckDefault_{{renderFilter.name}}" style="transform: scale(1.5);" (change)="checkboxChange($event)" [checked]="checkBoxFilter?.selected">
      <label class="form-check-label ml-1 col text-nowrap" for="flexSwitchCheckDefault_{{renderFilter.name}}" translate>{{renderFilter.displayName || renderFilter.name}}</label>
    </div>
  </div>

  <div *ngSwitchCase="'ColorConfigBaseFilter'">
    <div ngbDropdown [class]="class" [autoClose]="'outside'" placement="bottom-left" (openChange)="handleDropdownOpen($event)">
      <button class="btn btn-block text-left top-filter-dropdown" [ngClass]="{ 'has-selection': hasSelection }" ngbDropdownToggle>
        <div class="d-flex align-items-center">
          <span translate>{{ renderFilter.displayName || renderFilter.name }}</span>
          <i class="fa float-right ml-2" [ngClass]="{ 'fa-chevron-down': !dropdownIsOpen, 'fa-chevron-up': dropdownIsOpen }"></i>
        </div>
      </button>
      <div ngbDropdownMenu class="top-filter-dropdown-list color-filter-panel p-2">
        <ul class="top-filter-colors d-flex flex-wrap m-0 p-0">
          <li
            *ngFor="let option of renderFilterValueList"
            [ngClass]="{ 'd-none': !option.valueId || option.hide, 'selected': option.selected }"
            [ngStyle]="{ 'background-color': option.valueId | lowercase }"
            [title]="option.valueName + ' (' + option.itemCountAfterFilter + ')'"
            (click)="option.selected ? deselectValue.emit(option.valueId) : selectValue.emit(option.valueId); updateHasSelection()"
          ></li>
        </ul>
      </div>
    </div>
  </div>

  <div *ngSwitchDefault>
    <div ngbDropdown [class]="class" [autoClose]="'outside'" placement="bottom-left" (openChange)="handleDropdownOpen($event)">
      <button class="btn btn-block text-left top-filter-dropdown" [ngClass]="{ 'has-selection': hasSelection }" ngbDropdownToggle>
        <div class="d-flex align-items-center">
          <span translate>
            {{ renderFilter.displayName || renderFilter.name }}
          </span>
          <i
            class="fa float-right ml-2"
            [ngClass]="{ 'fa-chevron-down': !dropdownIsOpen, 'fa-chevron-up': dropdownIsOpen }"
          ></i>
        </div>
      </button>
      <ul class="top-filter-dropdown-list" ngbDropdownMenu>
        <li *ngIf="renderFilter.valueList.length > 0">
          <lib-filter-list-search (searchUpdated)="setSearch($event)"></lib-filter-list-search>
        </li>
        <li *ngIf="renderFilterValueList == 0">
          <span translate>NO_RESULTS_FOUND</span>
        </li>

        @if (!!renderFilter.filterShowMoreItemNumber) {
          @for (option of renderFilterValueListWithoutHide.slice(0, filterShowMoreItemNumber || (renderFilterValueListWithoutHide.length)); track option.valueId) {
            <ng-container *ngTemplateOutlet="normalFilterOptions; context: { $implicit: option }"></ng-container>
          }
        } @else {
          @for (option of renderFilterValueList; track option.valueId) {
            <ng-container *ngTemplateOutlet="normalFilterOptions; context: { $implicit: option }"></ng-container>
          }
        }

        <ng-template #normalFilterOptions let-option>
          <li [ngClass]="{ 'd-none': !option.valueId || option.hide }">
            <button
              class="btn top-filter-item w-100 text-left"
              (click)="option.selected ? deselectValue.emit(option.valueId) : selectValue.emit(option.valueId); updateHasSelection()"
              translate
            >
              <i class="far" [ngClass]="{ 'fa-square': !option.selected, 'fa-check-square': option.selected }"></i>
              <img *ngIf="renderFilter.type === 'IconConfigBaseFilter' && option.icon?.includes('http')" src="{{option.icon}}" alt="{{ option.valueName }}" class="filter-image mx-1">
              <span class="value-name"> {{ renderFilter.translateValues ? (option.valueName | translate) : option.valueName }} </span> <span class="float-right">{{ option.itemCountAfterFilter }}</span>
              <i *ngIf="renderFilter.type === 'SubSimpleConfigBaseFilter'"
                class="fa-solid ml-1" [ngClass]="{ 'fa-chevron-down': !option.selected, 'fa-chevron-up': option.selected }"></i>
            </button>
            <ul [ngbCollapse]="!option.selected" (ngbCollapseChange)="option.selected = $event" *ngIf="renderFilter.type === 'SubSimpleConfigBaseFilter'" class="no-bullets" #collapse="ngbCollapse">
              <li *ngFor="let subOption of option.subValueList" [ngClass]="{ 'd-none': !option.valueId || option.hide }">
                <button
                  class="btn top-filter-item w-100 text-left pr-1"
                  (click)="subOption.selected ? deselectSubValue.emit({option: option.valueId, subOption: subOption.valueId}) : selectSubValue.emit({option: option.valueId, subOption: subOption.valueId})"
                  translate
                >
                  <i class="fa-circle" [ngClass]="{ 'fa-regular': !subOption.selected, 'fa-solid': subOption.selected }"></i>
                  {{ subOption.valueName }} <span class="float-right">{{ subOption.itemCountAfterFilter }}</span>
                </button>
              </li>
            </ul>
          </li>
        </ng-template>

        @if (renderFilter.filterShowMoreItemNumber && renderFilter.filterShowMoreItemNumber < renderFilterValueListWithoutHide.length) {
          <li>
            <button
              class="btn top-filter-item w-100 text-left"
              (click)="filterShowMoreItemNumber ? (filterShowMoreItemNumber = undefined) : (filterShowMoreItemNumber = renderFilter.filterShowMoreItemNumber)"
              translate
            >
              <span class="value-name">
                {{ (filterShowMoreItemNumber ? 'SHOW_MORE' : 'SHOW_LESS') | translate }}
                @if (filterShowMoreItemNumber) {
                  <i class="fa-solid fa-chevron-down"></i>
                } @else {
                  <i class="fa-solid fa-chevron-up"></i>
                }
              </span>
            </button>
          </li>
        }
      </ul>
    </div>
  </div>
</div>
